import { getAuthAxios } from "@artprov/design-system";

/**
 * Obtiene el rol del usuario autenticado
 * Endpoint del backend: GET /auth/user/me
 * Retorna: { data: { rol: "AUTORIZANTE" | "SOLICITANTE" } }
 */
export const getRolUsuario = async () => {
    try {
        const response = await getAuthAxios("default").get('/auth/user/me');
        return response.data.data;
    } catch (error) {
        console.error("Error obteniendo rol del usuario:", error);
        throw error;
    }
};
